<template>
    <div class="bg-wrap">
        <div class="banner" v-if="this.avatar==null">
            <img src="../../assets/img/qkds_bg_screen_1.jpg">
        </div>
        <div class="player" v-if="this.avatar!=null&&this.avatar!=''">
            <img :src="getHead()" v-if="this.avatar!=null">
            <span>{{name}}</span>
        </div>
        <div class="content-wrap" v-if="this.avatar!=null">
            <div class="content">
                <div class="item" v-for="(value,i) in data" v-bind:key="i">
                    <span class="info">
<!--                        <span class="answer-key">-->
<!--                           {{value.question.question}} {{titleHint(value.question.sort)}}-->
<!--                        </span>-->

                         <span class="answer-key" v-html="toQuestion(value.question)" ></span>

                        <span class="answer-value" :class="v.isPlayerAnswer==1?'light':''"  v-for="(v,index) in value.questionResolve" v-bind:key="index" >
                                {{v.resolve_order}}、{{v.resolve}}
                        </span>
                        <span class="standard-value" v-if="showStandardAnswer(value.questionResolve)">
                            正确答案: {{getQuestionStandardAnswer(value.questionResolve)}}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getPlayerAnswer,getOnePlayer} from "../../assets/js/api";

    export default {
        data() {
            return {
                questionId:1,
                value: "",
                question:"",
                type:this.$route.query.type,
                answer:"",
                playerId: this.$route.query.playerId,
                data:[],
                name:"",
                avatar:null,
                bgshow:true
            }
        },
        mounted(){
            this.initWebSocket();
            if(this.playerId!=null){
                this.toGetOnePlayer(this.playerId)
                this.toGetPlayerAnswer(this.playerId,this.type)
            }
        },
        methods:{
            toQuestion(question){
                return question.question + this.titleHint(question.sort)
            },
            showStandardAnswer(resolves){
                var show =false
                for(var item of resolves){
                    console.log(item)
                    if(item.isPlayerAnswer==1){
                       show = true;
                    }
                }
                return show
            },

            getQuestionStandardAnswer(resolves){
                var answer =""
                for(var item of resolves){
                    console.log(item)
                    if(item.is_answer==1){
                        answer+=(item.resolve_order+"、")
                    }
                }
                return answer
            },

            getHead(){
                // console.log("getHead=",this.avatar);
                return (this.avatar!=null&&this.avatar!='')?this.avatar: require("@/assets/img/head.png");
            },
            titleHint(sort){
                switch (sort) {
                    case 1:
                        return "(单选题)"
                    case 2:
                        return "(判断题)"
                    case 3:
                        return "(多选题)"
                    default:
                        return ""
                }
            },
            async toGetOnePlayer(playerId){
                    if(playerId==0) {
                        this.avatar = ""
                        this.name = ""
                        this.getHead()
                    }
                    const res = await getOnePlayer({playerId});
                    // console.log(res)
                    if(res.data.success){
                        this.avatar = res.data.data.avatar
                        this.name = res.data.data.name
                    }
            },
            async toGetPlayerAnswer(playerId,type){
                    const res = await getPlayerAnswer({playerId,type});
                    console.log(res,"9999999")
                    this.data = res.data.data
            },
            initWebSocket: function () {
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
                console.log("--------websocketc初始化-------")
            },
            websocketonopen: function () {
                console.log("WebSocket连接成功");
            },
            websocketonerror: function (e) {
                console.log("WebSocket连接发生错误"+e.code);
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e.data)
                // this.toReload();//页面刷新
                var da =e.data;
                console.log(da,"data")
                /**
                 * data : playerId;type;isHost
                 */
                var isHost = da.split(";")[2]
                if(isHost==1){ //主持人，刷新
                    this.playerId = da.split(";")[0]
                    this.type = da.split(";")[1]
                    this.toGetPlayerAnswer(this.playerId,this.type)
                    this.toGetOnePlayer(this.playerId);
                }else{ //选手
                    if(this.playerId ==da.split(";")[0]&&this.type == da.split(";")[1]){
                        this.toGetPlayerAnswer(this.playerId,this.type)
                        this.toGetOnePlayer(this.playerId);
                    }
                }

            },
            websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
            },
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/qkds_bg_screen.jpg") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .content-wrap {
        display: flex;
        flex-flow: column;
        align-items: center;
        position: relative;
    }
    .content {
        margin-top: 20px;
        width: 100%;
        overflow: auto;
        margin-bottom: 50px;
    }
    .item{
        display: flex;
        flex-flow: row;
        align-items: flex-start;
        color: #000;
        font-size: 32px;
        margin: 10px;
        text-align: left;
        .index{
            margin: 2px 10px 0 10px;
        }
        .info{
            display: flex;
            flex-flow: column;
            padding-bottom: 20px;
            border-bottom: 1px #b30b19 solid;
            flex-grow: 1;

            margin: 0px 20px;

        }
    }
    .info .answer-key{
        word-wrap:normal;
        word-break:break-all;
        margin-bottom: 5px;
    }
    .info .answer-value{
        margin: 2px 0;
        display: flex;
        flex-flow: row;
        justify-content: start;
        text-indent: 5px;
        input[type="checkbox"]{
            margin-right: 50px;
        }
    }
    .info .standard-value{
        margin: 10px 0;
        color: #f29600;
        font-weight: bold;
        font-size: 25px;
    }

    .light{
        background: #0082C5;
        border-radius: 20px;
        padding: 0 5px;
    }

    .answer{
        color: #FFFFFF;
        font-size: 32px;
        text-align: left;
        margin-left: 10px;
    }

    .player{
        margin: 0 auto;
        img{
            margin-top: 10px;
            /*display: block;*/
            width: 100px;
            height: 100px;
            border-radius: 50%;
        }
        span{
            display: block;
            color: #000;
            font-size: 30px;
            margin-top: 10px;
        }
    }

    .banner{
        /*width: 100%;*/
        /*height: 185px;*/
        /*background: #FFF url("../../assets/img/plus_banner.jpg") no-repeat;*/
        /*background-size: contain;*/
        width: 100%;
        img{
            width:100%;
            /*height: 700px;*/
            /*max-height: 200px;*/
            object-fit: fill;
        }
    }



</style>